import { render, staticRenderFns } from "./SystemActivityPage.vue?vue&type=template&id=d34b9b84"
import script from "./SystemActivityPage.vue?vue&type=script&lang=js"
export * from "./SystemActivityPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports